<script setup>
import { defineEmits, defineProps } from 'vue';
import IconClose from '../../../icons/IconClose.vue';
import IconMinimize from '../../../icons/IconMinimize.vue';
import PgeButton from '../PgeButton.vue';

defineProps({
  header: {
    type: Boolean,
    default: true,
  },
  darkHeader: {
    type: Boolean,
    default: false,
  },
  onCloseText: {
    type: String,
    default: null,
  },
  onSuccessText: {
    type: String,
    default: null,
  },
  width: {
    type: String,
    default: '80%',
  },
  height: {
    type: String,
    default: 'auto',
  },
  maxWidth: {
    type: String,
    default: '328px',
  },
  maxHeight: {
    type: String,
    default: '600px',
  },
  loadingContainerHeight: {
    type: String,
    default: '219px',
  },
  closeIconMinimize: {
    type: Boolean,
    default: false,
  },
  closeHeaderButton: {
    type: Boolean,
    default: false,
  },
  isContentLoading: {
    type: Boolean,
    default: false,
  },
  isSuccessButtonDisabled: {
    type: Boolean,
    default: false,
  },
  customFooter: {
    type: Boolean,
    default: false,
  },
  bodyBackground: {
    type: String,
    default: '#fff'
  }
});

const emit = defineEmits(['close', 'success']);

function handleClose() {
  emit('close');
}

function handleSuccess() {
  emit('success');
}
</script>

<template>
  <div class="modal">
    <div class="modal__body" :style="{ width, height, maxWidth, maxHeight, background: bodyBackground }">
      <div :class="`modal__header ${darkHeader ? 'dark' : ''}`" v-if="header">
        <slot name="header" />
        <button v-if="closeHeaderButton" @click="handleClose">
          <icon-minimize v-if="closeIconMinimize" :color="darkHeader ? '#ffffff' : '#4B444D'" />
          <icon-close v-else :color="darkHeader ? '#ffffff' : '#4B444D'" />
        </button>
      </div>

      <div v-if="closeHeaderButton && !header" class="modal__body--header-close">
        <button @click="handleClose">
          <icon-minimize v-if="closeIconMinimize" :color="darkHeader ? '#ffffff' : '#4B444D'" />
          <icon-close v-else :color="darkHeader ? '#ffffff' : '#4B444D'" />
        </button>
      </div>

      <div class="modal__content" :style="{ height: isContentLoading ? loadingContainerHeight : '100%' }">
        <slot />
      </div>

      <div v-if="customFooter" class="modal__footer">
        <slot name="footer" />
      </div>

      <div class="modal__footer" v-else-if="onCloseText || onSuccessText">
        <pge-button v-if="onCloseText" :label="onCloseText" template="text" @click="handleClose" />
        <pge-button v-if="onSuccessText" :label="onSuccessText" template="filled" :disabled="isSuccessButtonDisabled"
          @click="handleSuccess" />
      </div>
    </div>
  </div>
</template>